import { UserType } from "../../Shared/types";
import { PreviewCommentUserType } from "../../../Infrastructure/Services/PostService.types";
import { EntityReactionType } from "../../Shared/Types/Reactions/ReactionTypes.types";
import { PostCommentsBaseInfo } from "../../../Infrastructure/Services/PostCommentsService.types";
import React from "react";

export type CommentImageType = { id: string; url: string };

export type ReplyContentType = {
    id: number;
    images?: CommentImageType[];
    isDeleted?: boolean;
    isSuspended?: boolean;
    linkoutUrl?: string;
    text?: string;
    user?: UserType;
};

export type ReplyComponentType = ReplyContentType & {
    onClick?(id: number): void;
};

export type CommentContentType = {
    date: Date;
    id: number;
    images: CommentImageType[];
    isDeleted: boolean;
    isEdited: boolean;
    isEditorial: boolean;
    isHighlighted: boolean;
    isOwnComment: boolean;
    isSuspended: boolean;
    user: UserType;
    linkoutUrl?: string;
    showAvatar?: boolean;
    text?: string;
    updatedAt?: Date;
};

export type CommentTypeProps = {
    commentContent: CommentContentType;
    onSwipe: (item: ReplyContentType) => void;
    commentReply?: ReplyContentType;
};

export type CommentType = {
    commentContent: CommentContentType;
    commentReactions: EntityReactionType[];
    cursor: number;
    id: number;
    postId: number;
    userReactions: string[];
    commentReply?: ReplyContentType;
};

export type UserCommentType = CommentType & {
    referencedPost: PostCommentsBaseInfo & {
        createdBy: PreviewCommentUserType;
        groupId: number;
        groupName: string;
        groupParentName: string | null;
    };
};

export type CommentPreviewType = {
    id: number;
    postId: number;
    text: string;
    date: Date;
    isEditorial: boolean;
    updatedAt: Date;
    user: PreviewCommentUserType;
    handleCommentPreviewOptionsClicked?: (comment: CommentType) => void;
    handleCommentPreviewReportClicked?: (comment: CommentType) => void;
    handleOnCommentPreviewClicked?: (e: React.MouseEvent<HTMLElement>) => void;
    commentReactions: EntityReactionType[];
    createReactOnPreviewComment?: (
        commentId: string,
        postId: number,
    ) => (reactionTypeName: string, action: string) => void;
    openCommentPreviewOwnerAvatarModal: (
        e: React.MouseEvent<HTMLElement>,
    ) => void;
    images?: CommentImage[];
    linkoutUrl?: string;
};

export type CommentImage = {
    id: number;
    url: string;
};

export type CommentTimestampType = {
    timestamp: string;
};

export type CommentInputType = {
    postId?: number;
    isSubmissionSuccess: boolean;
    messageReply?: ReplyContentType;
    setIsSubmissionSuccess: (value: boolean) => void;
    setReplyMessage: (item: ReplyContentType) => void;
    onSubmit: (postId: number, data: PostCommentInputType) => void;
    onEditSubmit: (
        commentId: number,
        postId: number,
        data: PostCommentInputType,
    ) => void;
    commentInputHeightChangeHandler: (value: number) => void;
    data?: CommentDataType;
    error: boolean;
    errorText: string;
    onChange: (value?: string) => void;
};

export type CommentDataType = {
    id: number;
    images: CommentImageType[];
    content?: string;
    linkoutUrl?: string;
};

export type PostCommentInputType = {
    text: string;
    images: any[];
};

export enum CommentSourceTypes {
    POST_DETAILS = "ts_post",
}
